import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isString from 'lodash/isString';
import {
  makeHttps,
  changeAssetDomain,
  convertGIFToVideoAssets,
  buildAssetUrlWithPresets
} from '../../../utils/cloudinary_asset_util';
import Image from '../image/image';
import matchMediaDesktop from '../../../utils/client_util';

class GifConverter extends Component {
  constructor() {
    super();
    this.state = {
      renderVideo: false
    };
  }

  componentDidMount() {
    const { assetSizes, src } = this.props;
    const isDesktop = matchMediaDesktop();
    const secureSrc = makeHttps(src);
    const fcDomainAsset = changeAssetDomain(secureSrc);
    const assetsWithPresets = buildAssetUrlWithPresets(
      fcDomainAsset,
      assetSizes,
      isDesktop
    );
    this.formats = convertGIFToVideoAssets(assetsWithPresets);

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ renderVideo: true });
  }

  render() {
    const { alt, src, assetSizes } = this.props;
    const videoFormats = this.formats;
    let tag = (
      <Image
        alt={alt}
        src={isString(src) ? src.replace(/.gif$/, '.jpg') : null}
        assetSizes={assetSizes}
      />
    );

    if (this.state.renderVideo) {
      tag = (
        <video
          className="video"
          poster={get(videoFormats, 'jpg')}
          playsInline
          loop
          preload
          autoPlay
          muted
        >
          <source type="video/webm" src={get(videoFormats, 'webm')} />
          <source type="video/mp4" src={get(videoFormats, 'mp4')} />
        </video>
      );
    }

    return <div>{tag}</div>;
  }
}

GifConverter.defaultProps = {
  // noLazy: false,
  assetSizes: {}
};

GifConverter.propTypes = {
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  // noLazy: PropTypes.bool,
  assetSizes: PropTypes.shape({
    large: PropTypes.shape({
      sizes: PropTypes.string,
      srcset: PropTypes.arrayOf(PropTypes.string)
    }),
    small: PropTypes.shape({
      sizes: PropTypes.string,
      srcset: PropTypes.arrayOf(PropTypes.string)
    })
  })
};

export default GifConverter;



// WEBPACK FOOTER //
// ./src/views/components/gif_converter/gif_converter.js